'use strict';

/**
 * Список заголовков
 * @constructor
 */
function HeaderList () {
  this.itemList = [];
}

/**
 * Добавить заголовок
 * @param headerItem {HeaderItem}
 */
HeaderList.prototype.addHeader = function (headerItem) {
  this.itemList.push(headerItem);

  return this;
};

/**
 * Список заголовков
 * @returns {HeaderItem[]}
 */
HeaderList.prototype.getHeaders = function () {
  return this.itemList;
};

/**
 * Колонка для заголовков
 * @constructor
 */
function HeaderItem () {
  this.labels = [];
  this.attributes = {};
  this.icon = null;
}

HeaderItem.prototype.addLabel = function (title, sortKey = null) {
  this.labels.push({
    title,
    sortKey,
    key: this.labels.length
  });

  return this;
};

HeaderItem.prototype.getLabels = function () {
  return this.labels;
};

HeaderItem.prototype.setAttributes = function (props) {
  this.attributes = props;
};

HeaderItem.prototype.getAttributes = function () {
  return this.attributes;
};

HeaderItem.prototype.setIcon = function (iconClass) {
  this.icon = iconClass;
};

HeaderItem.prototype.getIcon = function () {
  return this.icon;
};

export default {
  HeaderList,
  HeaderItem
};



// WEBPACK FOOTER //
// ./src/classes/collections/headerList.js